import styled from 'styled-components';
export const RowGroup = styled.div `
  position: relative;
`;
export const Placeholder = styled.div `
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: var(--bg-secondary);
`;
